<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else class="block-container">
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0" v-if="!$isEmpty($query)">
        <span v-if="channel&&channel.name">{{channel.name}} -</span>
        <span v-if="school&&school.name">{{school.name}} -</span>
        <span>部门</span>
      </h3>
      <div class="pull-right">
        <el-button type="default" @click="$router.back()" v-if="!$isEmpty($query)">返回</el-button>
      </div>
    </div>
    <div class="block">
      <el-row :gutter="20">
        <el-col :span="7">
          <div class="el-tree">
            <div class="tree-container">
              <div class="el-tree-node" v-for="type in department_types" :key="type.name"
                   :class="[{'is-expanded':type.$$open}]">
                <div class="el-tree-node__content" @click="type.$$open=!type.$$open">
                  <span class="el-tree-node__expand-icon el-icon-caret-right"
                        :class="[{expanded:type.$$open}]"></span>
                  <span class="el-tree-node__label">{{type.name}}</span>
                </div>
                <div class="el-tree-node__children" v-if="type.$$open">
                  <div v-if="!type.departments.length" class="empty-block">
                    <div class="empty-text">暂无数据</div>
                  </div>
                  <template v-else>
                    <div class="el-tree-node" v-for="item in type.departments" :key="item.name"
                         :class="[{'is-current':department === item}]">
                      <div class="el-tree-node__content" @click="toggleDepartment(item)">
                        <span class="el-tree-node__expand-icon is-leaf"></span>
                        <span class="el-tree-node__label">{{item.name || '未命名'}}</span>
                        <div class="department-teacher-total">{{item.total}}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="text-center">
              <router-link v-if="$location.admin_department_config.auth()"
                           :to="$location.admin_department_config()"
                           class="link-success">
                <icon name="cog"></icon>
                配置部门结构
              </router-link>
            </div>
          </div>
        </el-col>
        <el-col :span="17">
          <div v-if="department" class="department-detail">
            <div class="clearfix">
              <div class="pull-left">
                <h4 class="m-v-0">{{department.name}}</h4>
              </div>
              <div class="pull-right">
                <el-button type="primary" :loading="department.$$loading>0" @click="showDialog">
                  添加/删除成员
                </el-button>
              </div>
            </div>
            <hr>
            <el-table :data="department.teachers" v-if="department.teachers" border>
              <el-table-column label="姓名" prop="name"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>
              <el-table-column label="学段" prop="grade"></el-table-column>
              <el-table-column label="学科" prop="subjects">
                <template slot-scope="scope">{{scope.row.subjects.join('、')}}</template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <router-link v-if="$location.admin_teacher_edit.auth()"
                               :to="$location.admin_teacher_edit({user_uid: scope.row.uid})"
                               class="el-button el-button--mini el-button--warning">编辑
                  </router-link>
                  <el-button type="warning" size="mini" :loading="department.$$loading>0"
                             @click="removeTeacher(scope.row)">移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="empty-block" v-else>
            <div class="empty-text">请选择一个部门</div>
          </div>
        </el-col>
      </el-row>
      <el-dialog title="添加/删除成员" width="33%" :visible.sync="visible">
        <template v-if="form">
          <el-form :model="form" ref="form">
            <el-form-item prop="teachers">
              <el-select multiple filterable :filter-method="filterTeacher"
                         v-model="form.teachers" class="full-width">
                <el-option v-for="teacher in filtered_teachers" :label="teacher.name"
                           :value="teacher.uid" :key="teacher.uid">
                  <span v-html="$highlight(teacher.name, teacher.$$pinyin.name)"></span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submit" :loading="department.$$loading>0">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy'
import * as Department from 'api/department'
import * as Teacher from 'api/teacher'
import * as Channel from 'api/channel'
import * as School from 'api/school'

export default {
  data () {
    return {
      ready: false,
      submit_loading: 0,
      departments: [],
      department_types: [],
      department: null,
      teacher: null,
      search: '',
      channel: null,
      school: null,
      form: null,
      visible: false,
    }
  },
  computed: {
    filtered_teachers () {
      return this.$search(this.teachers, this.search, ['name'])
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let query = this.$query
        let [departments, department_types, teachers, channel, school] = await Promise.all([
          Department.list(query),
          Department.types(query),
          Teacher.list(query),
          query.channel_uid ? Channel.get(query) : null,
          query.school_uid ? School.get(query) : null,
        ])
        this.setUpDepartment(departments, department_types)
        department_types.forEach(type => type.$$open = false)
        this.departments = departments
        this.department_types = department_types
        if (departments.length) this.toggleDepartment(departments[0])
        this.teachers = teachers
        this.channel = channel
        this.school = school
        this.ready = true
      })
    },
    filterTeacher (search) {
      this.search = search
    },
    setUpDepartment (departments, department_types) {
      let department_groups = groupBy(departments, 'type')
      department_types.forEach(type => {
        type.departments = department_groups[type.en_name] || []
        type.departments.forEach(department => department.$$type = type)
      })
      departments.forEach(department => {
        department.teachers = department.teachers || null
        department.department_uid = department.uid
        department.school_uid = this.$query.school_uid
      })
    },
    toggleDepartment (department) {
      this.department = department
      department.$$type.$$open = true
      if (department.teachers) return
      this.$guard(department, '$$loading')(async () => {
        department.teachers = await Department.teacher_list({department_uid: department.uid})
        department.total = department.teachers.length
      })
    },
    showDialog () {
      this.form = {
        teachers: this.department.teachers.map(teacher => teacher.uid),
      }
      this.filterTeacher('')
      this.visible = true
    },
    submit () {
      let department = this.department
      let teachers = this.form.teachers
      this.$guard(department, '$$loading')(async () => {
        await Department.teacher_edit({
          department_uid: department.uid,
          teachers: teachers,
        })
        department.teachers = await Department.teacher_list({department_uid: department.uid})
        department.total = department.teachers.length
        this.form = null
        this.visible = false
      })
    },
    async removeTeacher (teacher) {
      let department = this.department
      let teachers = department.teachers.filter(item => item.uid !== teacher.uid)
      this.$guard(department, '$$loading')(async () => {
        await Department.teacher_edit({
          department_uid: department.uid,
          teachers: teachers.map(item => item.uid),
        })
        department.teachers = teachers
        department.total--
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";
@import "src/scss/var/app";

.block-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.block {
  height: 100%;
  background-color: $color-block-background;
  padding: 20px;
  flex: 1;
  display: flex;
}

.el-row {
  width: 100%;
  height: 100%;
  display: flex;
  .el-col {
    height: 100%;
  }
}

.el-tree {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #d1dde5;
  .tree-container {
    overflow: auto;
    flex: 1;
  }
}

.el-tree-node__label {
  flex: 1;
}

.el-tree-node .el-tree-node .el-tree-node__label {
  padding-left: 1em;
}

.is-current .el-tree-node__content {
  background-color: mix($color-success, white, 10%);
}

.el-tree-node__content {
  .department-teacher-total {
    float: right;
    margin-right: 10px;
  }
}

.department-detail {
  height: 100%;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/department/Department.vue